module.exports = __webpack_public_path__ + "static/img/12.45759a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/12.png
// module id = u77e
// module chunks = 0